import { background, brandPrimary, header } from '@Styles/colors';
import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { CssSelectors } from '../../../styles/styles';

const { spacing, common, typography } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
		maxWidth: 600,
		alignItems: 'center',
		paddingLeft: 200,
		paddingRight: 200,
	},
	tabView: {
		width: '100%',
	},
	tabViewTabs: {
		display: 'flex',
		borderBottom: common.border,
	},
	tabItemSelected: {
		borderBottom: `1px solid ${brandPrimary}`,
	},
	tabViewItem: {
		color: header,
		display: 'inline-flex',
		flexBasis: 'auto',
		fontSize: typography.fontSizes.sm,
		height: spacing.xxl,
		padding: `${spacing.sm} ${spacing.xl}px`,
		textAlign: 'center',
		textTransform: 'uppercase',
		whiteSpace: 'nowrap',
		gap: spacing.sm,
	},
	section: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
		alignItems: 'center',
		padding: spacing.md,
	},
	inProgressIconContainer: {
		...CssSelectors.allChildren({
			marginTop: spacing.xl,
			opacity: 0.15,
		}),
		background,
		borderRadius: '50%',
		height: 180,
		margin: '30px auto 40px',
		textAlign: 'center',
		width: 180,
	},
});
